import primaryComponents from "../../../primaryComponents";
import Validation from "./Validation";
import useEquityAccountSettings from "./useEquityAccountSettings";
import styles from "../../../../pages/appPages/Accounting/AccountSettings/styles.module.scss";

const EquityAccountSettings = ({
  filterAccountBySubAccountType,
  findAccountMapping,
  updateAccountMappingMutation,
  handleAccountMappingSubmit,
}) => {
  const { equityAccountMapping, setEquityAccountMapping } =
    useEquityAccountSettings(findAccountMapping);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = Validation({ equityAccountMapping });
  return (
    <form className="p-3" onSubmit={handleSubmit(handleAccountMappingSubmit)}>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Owner&apos;s Capital Account</h5>
          <span>
            The equity account used to track owner&apos;s initial and additional
            investments into the business
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("owners_capital")}
            control={control}
            name="owners_capital_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("owners_capital_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setEquityAccountMapping((prev) => ({
                ...prev,
                owners_capital_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.owners_capital_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Owner&apos;s Drawing Account</h5>
          <span>
            The equity account used to track owner withdrawals or drawings from
            the business
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("owners_drawings")}
            control={control}
            name="owners_drawing_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("owners_drawing_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setEquityAccountMapping((prev) => ({
                ...prev,
                owners_drawing_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.owners_drawing_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Retained Earnings Account</h5>
          <span>
            The equity account used to track accumulated profits or losses that
            are retained in the business rather than distributed to owners
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("retained_earnings")}
            control={control}
            isDisabled={true}
            name="retained_earnings_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("retained_earnings_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setEquityAccountMapping((prev) => ({
                ...prev,
                retained_earnings_account: value,
              }));
            }}
            idKey={"id"}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={updateAccountMappingMutation.isLoading}
          isLoading={updateAccountMappingMutation.isLoading}
          loadingText={"Updating..."}
        >
          Save Changes
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default EquityAccountSettings;
